import { useContext } from "react";
import { IAddon, IUseAddonsProps } from "./types";
import { AddonsContext } from "./context";
import { isYearlyPlan } from "@common/utils/plan";
import { isDWHAddOn } from "./utils";

export function useAddons({
  yearly: filterYearly,
  dwh: filterDWH,
}: IUseAddonsProps = {}): IAddon[] {
  const addOns = useContext(AddonsContext);

  return addOns
    .filter(({ alias }) => {
      if (filterYearly === undefined) {
        return true;
      }

      return filterYearly ? isYearlyPlan(alias) : !isYearlyPlan(alias);
    })
    .filter(({ alias }) => {
      if (filterDWH === undefined) {
        return true;
      }

      return filterDWH ? isDWHAddOn(alias) : !isDWHAddOn(alias);
    });
}
